import { createActionThunk } from "redux-thunk-actions";

import {
  getOwnRecipes,
  deleteRecipes as deleteRecipesService,
  updateRating as updateRatingService,
  updateRank as updateRankService,
  getIngredients as getIngredientsService,
  addMealPlanService,
  shareService,
  checkUsedRecipes as checkUsedRecipesService,
} from "../services/RecipeService";
import {
  RECIPE_MANAGEMENT_INITIALIZATION,
  RECIPE_MANAGEMENT_INGREDIENT_TOGGLE,
  RECIPE_MANAGEMENT_INGREDIENT_FILTER,
  RECIPE_MANAGEMENT_RECIPE_SELECT_TOGGLE,
  RECIPE_MANAGEMENT_DELETE,
  RECIPE_MANAGEMENT_UPDATE_RATING,
  RECIPE_MANAGEMENT_UPDATE_RANK,
  ON_CHANGE_MEALPLANMODAL,
  ON_SUBMIT_MEALPLANMODAL,
  ON_CHANGE_SHARE,
  ON_SHARE,
  getFailed,
  getStarted,
  getSucceeded,
  CHECK_USER_RECIPES,
  SHARE_SUCCESS_STATUS,
  CLEAR_EDIT_REGIMEN,
} from "./constant";
import { change } from "redux-form";

const initialization = createActionThunk(
  RECIPE_MANAGEMENT_INITIALIZATION,
  (cat) => getOwnRecipes(cat)
);
const categorySelected = createActionThunk(
  RECIPE_MANAGEMENT_INITIALIZATION,
  (cat) => getOwnRecipes(cat.target.value)
);
const ingredientToggle = (id, isExpand, isDone) => {
  if (isExpand || (typeof isDone != "undefined" && isDone)) {
    return (dispatch) => {
      dispatch({
        type: RECIPE_MANAGEMENT_INGREDIENT_TOGGLE,
        item: { _id: id },
      });
    };
  } else {
    return async (dispatch) => {
      try {
        const recipe = {
          id: id,
        };
        let data = await getIngredientsService(recipe);
        dispatch({
          type: RECIPE_MANAGEMENT_INGREDIENT_TOGGLE,
          item: data,
        });
      } catch (e) {
        console.log(e);
        // return dispatch({type: getFailed(GET_RECIPE), error: e});
      }
    };
  }
};
const ingredientFilter = (search, sortBy, name = "") => {
  // if (typeof search == "undefined") search = "";
  return (dispatch) => {
    dispatch({
      type: RECIPE_MANAGEMENT_INGREDIENT_FILTER,
      search: search,
      sortBy: sortBy,
      name,
    });
  };
};
const recipeSelectToggle = (recipe) => {
  return (dispatch) => {
    dispatch({
      type: RECIPE_MANAGEMENT_RECIPE_SELECT_TOGGLE,
      id: recipe._id,
      recipe: recipe.recipe,
    });
  };
};
const deleteRecipes = createActionThunk(RECIPE_MANAGEMENT_DELETE, (ids, cat) =>
  deleteRecipesService(ids, cat)
);
const updateRating = createActionThunk(
  RECIPE_MANAGEMENT_UPDATE_RATING,
  (id, rating, cat) => updateRatingService(id, rating, cat)
);
const updateRank_2 = (id, rank, rankBefore, cat) => async (dispatch) => {
  try {
    await updateRankService(id, rank, rankBefore, cat);
  } catch (error) {
    console.log("error is", error);
  }
};

const updateRank = (id, rank, rankBefore, cat) => {
  return async (dispatch) => {
    dispatch({
      type: RECIPE_MANAGEMENT_UPDATE_RANK,
      payload: { id, rank, rankBefore, cat },
    });
  };
};
const onSubmitMealPlanner = createActionThunk(
  ON_SUBMIT_MEALPLANMODAL,
  (mPlan, selectedItems, history) =>
    addMealPlanService(mPlan, selectedItems, history)
);

const onChangeMealPlanner = (e) => {
  return async (dispatch) => {
    dispatch({
      type: ON_CHANGE_MEALPLANMODAL,
      name: e.target.name,
      value: e.target.value,
    });
  };
};
const shareChange = (e) => {
  return async (dispatch) => {
    dispatch({
      type: ON_CHANGE_SHARE,
      name: "email",
      value: e,
    });
    // dispatch(change("formRecipeManagement", "email", "7777"));
  };
};
const share = (cat, shareIds, email) => {
  return async (dispatch) => {
    dispatch({
      type: getStarted(ON_SHARE),
    });
    try {
      await shareService(cat, shareIds, email);
      dispatch({
        type: getSucceeded(ON_SHARE),
        // item: data,
      });
    } catch (e) {
      dispatch({
        type: getFailed(ON_SHARE),
        item: e.message,
      });
      console.log(e.message);
    }
    // dispatch(change("formRecipeManagement", "email", "7777"));
  };
};

const recipeSelectedForDelete = (id) => {
  return async (dispatch) => {
    dispatch({
      type: getStarted(CHECK_USER_RECIPES),
    });
    try {
      let check = await checkUsedRecipesService(id);
      dispatch({
        type: getSucceeded(CHECK_USER_RECIPES),
        check,
      });
    } catch (e) {
      dispatch({
        type: getFailed(CHECK_USER_RECIPES),
        item: e.message,
      });
      console.log(e.message);
    }
  };
};

const shareSuccessStatus = () => {
  return async (dispatch) => {
    dispatch({
      type: SHARE_SUCCESS_STATUS,
    });
  };
};

const clearManageRegimen = () => {
  return async (dispatch) => {
    dispatch({
      type: CLEAR_EDIT_REGIMEN,
    });
  };
};

export default {
  initialization,
  ingredientToggle,
  ingredientFilter,
  recipeSelectToggle,
  clearManageRegimen,
  deleteRecipes,
  updateRating,
  updateRank,
  updateRank_2,
  categorySelected,
  onChangeMealPlanner,
  onSubmitMealPlanner,
  shareChange,
  share,
  recipeSelectedForDelete,
  shareSuccessStatus,
};



// WEBPACK FOOTER //
// ./src/actions/recipeManagementActions.js